import { List } from '@mui/material'

import { BaseMenuDrawer } from './components/BaseMenuDrawer'
import { MenuItem } from './components/MenuItem'
import type { MenuItem as MenuItemType } from './lib/MenuItem'

type Props = {
  forceTemporary?: boolean
  menuItems: MenuItemType[]
  open: boolean
  onClose: () => unknown
}

export const MenuDrawer = ({ forceTemporary = false, menuItems, open, onClose }: Props) => {
  return (
    <BaseMenuDrawer open={open} onClose={onClose} forceTemporary={forceTemporary}>
      <List disablePadding role="menu">
        {menuItems.map((item) => (
          <MenuItem key={`${item.primaryText}-${item.linkTo}`} menuItem={item} />
        ))}
      </List>
    </BaseMenuDrawer>
  )
}
